import React, { useState, useEffect } from 'react';
import { oauthAPI } from '../../services/api';
import DatePicker from './DatePicker';
import { CITIES } from '../../constants/cities';
import './CharacterInfoEditor.css';

const CharacterInfoEditor = ({ character, onUpdate }) => {
  const [email, setEmail] = useState(character?.email || '');
  const [residentialAddress, setResidentialAddress] = useState(character?.residentialAddress || character?.address || '');
  const [city, setCity] = useState(character?.city || '');
  const [phone, setPhone] = useState(character?.phone || '');
  const [dateOfBirth, setDateOfBirth] = useState(character?.dateOfBirth || '');
  const [routingNumber, setRoutingNumber] = useState(character?.routingNumber || '');
  const [portfolio, setPortfolio] = useState(character?.portfolio || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setEmail(character?.email || '');
    setResidentialAddress(character?.residentialAddress || character?.address || '');
    setCity(character?.city || '');
    setPhone(character?.phone || '');
    setDateOfBirth(character?.dateOfBirth || '');
    setRoutingNumber(character?.routingNumber || '');
    setPortfolio(character?.portfolio || '');
  }, [character]);

  const handleSave = async () => {
    if (!character) return;

    setSaving(true);
    setError(null);
    setSuccess(false);

    try {
      const cleanValue = (val) => {
        if (!val) return null;
        if (typeof val === 'string' && val.trim() === '') return null;
        return typeof val === 'string' ? val.trim() : val;
      };

      const response = await oauthAPI.updateCharacter(
        character.id,
        cleanValue(email),
        cleanValue(residentialAddress),
        cleanValue(phone),
        cleanValue(dateOfBirth),
        cleanValue(residentialAddress),
        cleanValue(city),
        cleanValue(routingNumber),
        cleanValue(portfolio)
      );
      if (response.success) {
        setSuccess(true);
        setTimeout(() => setSuccess(false), 3000);
        if (onUpdate) {
          onUpdate();
        }
      } else {
        setError(response.message || 'Failed to update character information');
      }
    } catch (err) {
      setError(err.message || 'Error updating character information');
    } finally {
      setSaving(false);
    }
  };

  if (!character) return null;

  return (
    <div className="character-info-editor">
      <div className="character-info-form">
        <div className="form-group">
          <label>Email (Forum/Discord)</label>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email, forum username, or Discord"
            className="character-info-input"
          />
        </div>
        <div className="form-group">
          <label>Residential Address</label>
          <input
            type="text"
            value={residentialAddress}
            onChange={(e) => setResidentialAddress(e.target.value)}
            placeholder="Enter street address"
            className="character-info-input"
          />
        </div>
        <div className="form-group">
          <label>City</label>
          <select
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className="character-info-input"
          >
            <option value="">Select a city</option>
            {CITIES.map(cityName => (
              <option key={cityName} value={cityName}>{cityName}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Phone</label>
          <input
            type="text"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Enter phone number"
            className="character-info-input"
          />
        </div>
        <div className="form-group">
          <label>Date of Birth</label>
          <DatePicker
            value={dateOfBirth}
            onChange={setDateOfBirth}
            className="character-info-input"
          />
        </div>
        <div className="form-group">
          <label>Routing Number</label>
          <input
            type="text"
            value={routingNumber}
            onChange={(e) => setRoutingNumber(e.target.value)}
            placeholder="Enter routing number"
            className="character-info-input"
          />
        </div>
        <div className="form-group">
          <label>Portfolio URL (Optional)</label>
          <input
            type="url"
            value={portfolio}
            onChange={(e) => setPortfolio(e.target.value)}
            placeholder="Enter portfolio URL"
            className="character-info-input"
          />
        </div>
        {error && (
          <div className="character-info-error">{error}</div>

        )}
        {success && (
          <div className="character-info-success">Character information updated successfully!</div>

        )}
        <button
          onClick={handleSave}
          disabled={saving}
          className="character-info-save-button"
        >
          {saving ? 'Saving...' : 'Save'}
        </button>

      </div>

    </div>

  );
};

export default CharacterInfoEditor;

